module.exports = __webpack_public_path__ + "img/bottomv3@2x.741908b6.png";